import { z } from "zod";
// Raw meeting data schema (with string dates from API)
export const RawMeetingDataSchema = z.object({
    id: z.string(),
    title: z.string(),
    description: z.string().optional(),
    startTime: z.string(), // ISO string from API
    endTime: z.string(), // ISO string from API
    meetingUrl: z.string().optional(),
    platform: z.string().optional(),
    callId: z.string().optional(),
    autoJoinEnabled: z.boolean(),
    // Optional server-computed fields for richer UI without extra roundtrips
    willJoin: z.boolean().optional(),
    schedulingOverride: z.enum(["default", "on", "off"]).optional(),
    status: z.enum(["upcoming", "current", "completed"]),
    attendees: z.array(z.object({
        name: z.string().optional(),
        email: z.string(),
    })),
});
// Raw current meeting response schema (with string dates from API)
export const RawCurrentMeetingResponseSchema = z.object({
    frontierStatus: z.enum(["not_joined", "joining", "active", "error"]),
    meeting: RawMeetingDataSchema.optional(),
});
